import React, { Component } from "react";
import { connect } from "react-redux";
import produce from "immer";
import { sessionWatchOn, sessionWatchOff } from "../../actions/sessionActions";
import Loading from "../Loading";
import Add from "./Add";
import Title from "./Title";

class Session extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.sessionWatchOn();
  }

  componentWillUnmount() {
    this.props.sessionWatchOff();
  }

  componentDidUpdate(prevProps, prevState) {}

  render() {
    const { name } = this.props.session;
    if (name === undefined) {
      return <Loading />;
    } else if (name === "") {
      return <Add />;
    } else if (name.length > 0) {
      return <Title title={name} />;
    } else {
      return <div>something's wrong..</div>;
    }
  }
}

const mapStateToProps = state => ({
  session: state.session
});

export default connect(
  mapStateToProps,
  { sessionWatchOn, sessionWatchOff }
)(Session);
